import {
  Tab as MuiTab,
  Tabs as MuiTabs,
  styled,
  tabClasses,
  tabsClasses,
} from '@mui/material';

export const Tabs = styled(MuiTabs)({
  [`.${tabsClasses.indicator}`]: {
    display: 'none',
  },
});

export const Tab = styled(MuiTab)(({ theme }) => ({
  padding: theme.spacing(0.2, 1),
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  background: 'transparent',
  border: `1px solid ${theme.palette.custom.OV.sys.onSurfaceVariant}`,
  margin: '0.5rem',
  borderRadius: '0.5rem',
  minHeight: `2rem`,

  [`&.${tabClasses.selected}`]: {
    background: theme.palette.custom.OV.sys.surfaceContainerHighest,
    border: `1px solid ${theme.palette.custom.OV.sys.surfaceContainerHighest}`,
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
  },
}));
